<template>
    <Loading>
        <div class="p-4">
            <Row class="input-row" rounded />
        </div>
    </Loading>
</template>

<script>
import Loading from '~/components/skeletons/base/Loading';
import Row from '~/components/skeletons/base/Row';

export default {
    name: 'SummarySkeleton',
    components: { Loading, Row },
};
</script>

<style scoped>
.input-row {
    height: 64px;
}
</style>
